import React from 'react';

import BrowseHomePage from 'app/components/browse/BrowseHomePage';
import { fetchBrowseConfig } from 'app/actions/browse/browseHomeActions';

export function BrowseHomePageRoute() {
  return <BrowseHomePage />;
}

// The pilot conversion for CORE-79042. `createLoader` replaces connectRoute's `getRouteData`:
// createAppRoutes binds it to the store and hangs the result on the route as its `loader`, so
// react-router owns the fetch on both sides -- the static handler's query() on the server, and the
// data router on client navigation.
//
// It still dispatches into Redux and returns nothing of its own. BrowseHomePage reads what it
// needs through selectors, exactly as before, and is untouched by this.
//
// Dropping connectRoute here is safe because this route passed it nothing else: no mapStateToProps,
// no mapDispatchToProps, no debounceOptions. fetchDataForCurrentRoutes finds work through the
// `getRouteData` static that connectRoute sets, so with connectRoute gone this route is invisible
// to the old pipeline and is driven solely by its loader.
BrowseHomePageRoute.createLoader = store => async () => {
  await store.dispatch(fetchBrowseConfig());
  return null;
};

export default BrowseHomePageRoute;
